import {
  Box,
  Heading,
  Icon,
  Input,
  Link,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
  VStack,
  useToast,
} from "@chakra-ui/react";
import React, { useRef, useState } from "react";
import { AiFillGithub, AiFillLinkedin, AiOutlineMail } from "react-icons/ai";
import { BsFillTelephoneFill } from "react-icons/bs";
import emailjs from "@emailjs/browser";
const initialMessageDetail = {
  name: "",
  user_email: "",
  subject: "",
  message: "",
};
const Contact = () => {
  const form = useRef();
  const [messageDetails, setMessageDetails] = useState(initialMessageDetail);
  const handleMessage = ({ target }) => {
    const { name, value } = target;
    setMessageDetails({ ...messageDetails, [name]: value });
  };
  const toast = useToast();
  const handleForm = async (e) => {
    e.preventDefault();
    try {
      let result = await emailjs.sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_PUBLIC_KEY
      );
      if (result.status === 200) {
        toast({
          title: "Email Sended successfully",
          position: "top",
          description: "I will be responed you very soon",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (err) {
      console.log("something went wrong");
      toast({
        title: "error occurred in sending mail ",
        position: "top",
        description: err,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }

    console.log(messageDetails);
  };

  return (
    <Box>
     
      <Box pt="10px">
        <Heading color="#00ade7" size="lg">
        Contact me
        </Heading>
      </Box>
      {/* <Box pt="10px">
      <Heading  color= "teal.400" size={["xs",null,"sm",null,"md"]}>Get in Touch</Heading>
</Box> */}
      <SimpleGrid templateColumns={["auto", null, "40% 50%"]} gap={{base:"30px",lg:"50px" }}mt={["10px",null,"20px",null,"30px"]}>
        <Box textAlign="start">
          <Heading  size={["xs",null,"sm",null,"md"]} color="#ff3f6c" textAlign="center" pb="15px">Get in Touch</Heading>
          <Text pt="5px">
            Got a project? Reach out and let's work together on something
            exciting. Big or small. Mobile or web.
          </Text>
          <SimpleGrid
            fontSize={{base:"xl",lg:"3xl"}}
            templateColumns="30px auto"
            justifyContent="start"
            alignItems="center"
            gap={["10px","15px","20px","25px"]}
            mt="25px"

          >
            <Link href="mailto:kakadem.b.99@gmail.com" isExternal>
              <Icon color="#D44638" as={AiOutlineMail} />
            </Link>
            <Text fontSize="lg">kakadem.b.99@gmail.com</Text>
            <Link
              href="https://www.linkedin.com/in/madhukar-kakade-767b8a89"
              isExternal
            >
          
              <Icon color="#0077B5" as={AiFillLinkedin} />
            </Link>
            <Text fontSize="lg">Linkedin</Text>
            <Link href="https://github.com/madhukarkakade" isExternal>
              <Icon color="black" as={AiFillGithub} />
            </Link>
            <Text fontSize="lg"> GitHub</Text>
            <Link href="https://wa.me/8446058359" title="8208080454" isExternal>
            
              <Icon color="blue.500" as={BsFillTelephoneFill} />
            </Link>
            <Text fontSize="lg">+91 8208080454</Text>
          </SimpleGrid>
        </Box>

        {/* message handled */}
        <form ref={form} onSubmit={handleForm}>
          <VStack alignItems="stretch" gap="15px">
            <Heading color="#ff3f6c" size="md">Message me</Heading>

            <Stack direction={["column", "row"]} gap="15px">
              <Input
                type="text"
                name="name"
                placeholder="Name"
                onChange={handleMessage}
                value={messageDetails.name}
                isRequired
              />
              <Input
                type="email"
                name="user_email"
                placeholder="Email"
                onChange={handleMessage}
                value={messageDetails.user_email}
                isRequired
              />
            </Stack>
            <Input
              type="subject"
              name="subject"
              placeholder="Subject"
              onChange={handleMessage}
              value={messageDetails.subject}
              isRequired
            />
            <Textarea
              type="text"
              name="message"
              placeholder="Message .."
              size="md"
              h="120px"
              isRequired={true}
              onChange={handleMessage}
              value={messageDetails.message}
            />
            <Input type="submit" value="Send message" color="white" bg="#ff3f6c"></Input>
          </VStack>
        </form>
      </SimpleGrid>
    </Box>
  );
};

export default Contact;
